import {useRouter} from 'next/router';
import {Flex, FlexProps, Text} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';
import type {Player} from '@eksab/features/competition/types';
import {getLanguage} from '@eksab/util/helpers';

import {ArrowToIcon} from './icons';

interface NewPositionIndicatorProps extends Omit<FlexProps, 'position'> {
  position: Player['position'];
}

export const NewPositionIndicator = ({position, ...props}: NewPositionIndicatorProps) => {
  const {locale} = useRouter();

  const t = useTranslate();

  return (
    <Flex align="center" gap="2" {...props}>
      <ArrowToIcon boxSize="3" transform="auto" color="white" scaleX={getLanguage(locale) === 'en' ? 1 : -1} />

      <Text as="span" fontSize="xs" color="green.400">
        {t(`fantasy.lineup.${position}`)}
      </Text>
    </Flex>
  );
};
